import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import EntryApp from './EntryApp'

function App() {
  return (
    <Router>
      <EntryApp />
    </Router>
  );
}

export default App;
